<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">订单统计</div>
          <div class="card-body">

            <Form ref="create" :model="formValidate" :label-width="100">
              <FormItem label="选择商品" prop="goods">
                <Spin size="large" v-if="data.length == 0"></Spin>
                <div v-else>
                  <div class="pictrueBox">
                    <div class="pictrue" v-for="item in data" :key="item.id" @click="goodsClick(item)"
                      :class="goods.indexOf(item.id)  != -1 ? 'active' : ''">
                      <img :src="item.front" alt="" />
                      <div class="text">{{ item.name }}</div>
                    </div>
                  </div>
                  <span v-show="goods.length == 0">* 未选择商品</span>
                  <Page :current="Number(current_page)" :total="Number(total)" :page-size="pageSize"
                    @on-change="pageChange" simple style="float: right" />
                </div>

              </FormItem>
              <FormItem label="查询区间" prop="goods">

                <DatePicker type="datetime" placeholder="请选择开始时间" @on-change="startChange" :editable="false"
                  style="width: 200px;margin-right:20px;margin-bottom: 10px"></DatePicker>
                <DatePicker type="datetime" placeholder="请选择结束时间" @on-change="endChange" :editable="false"
                  style="width: 200px;margin-right:20px;margin-bottom: 10px"></DatePicker>
                <Button type="primary" style="margin-right: 10px;" @click="_getNormsStatistics"
                  :loading="loading">立即查询</Button>
                <Button @click="exportData" :disabled="Statistics.length > 0?false:true">导出</Button>
              </FormItem>




            </Form>


            <Table ref="table" :columns="columns" :data="Statistics" border v-if="Statistics.length > 0">

            </Table>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getStockShop,
    getNormsStatistics
  } from "@/api/admin";

  export default {
    data() {
      return {
        goods: [],
        formValidate: {
          starttime: "",
          endtime: "",
        },
        columns: [{
            title: "规格名称",
            key: "name",
            minWidth: 220,
          },
          {
            title: "所属商品",
            key: "goods_name",
            align: "center",
            minWidth: 200,
          },
          {
            title: "商品单价",
            key: "price",
            align: "center",
            minWidth: 100,
          },
          {
            title: "出售数量",
            align: "center",
            key: "num",
            minWidth: 100,
          },
          {
            title: "已完成订单数",
            key: "success_order",
            align: "center",
            minWidth: 100,
          },
          {
            title: "订单总金额",
            key: "all_money",
            align: "center",
            minWidth: 200,
          },

        ],

        pageIndex: 1,
        pageSize: 10,
        total: "",
        current_page: "",
        data: [],
        Statistics: [],
        loading: false
      };
    },
    created() {
      this._getStockShop();
    },

    watch: {

    },
    methods: {
      exportData(type) {
        this.$refs.table.exportCsv({
          filename: this.formValidate.starttime + '至' + this.formValidate.endtime
        });
      },
      startChange(e) {
        this.formValidate.starttime = e
      },
      endChange(e) {
        this.formValidate.endtime = e
      },
      // 获取数据
      _getNormsStatistics() {
        this.loading = true
        getNormsStatistics({
          goods: this.goods,
          starttime: this.formValidate.starttime,
          endtime: this.formValidate.endtime,
        }).then(res => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this.Statistics = res.data
            this.loading = false
          } else {
            this.loading = false
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
        })
      },
      // 获取商品
      _getStockShop() {
        getStockShop({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        }).then((res) => {
          this.data = res.data.data;
          this.formValidate.goods = res.data.data[0];

          this.total = res.data.total;
          this.current_page = res.data.current_page;
        });
      },
      // 选择/反选商品
      goodsClick(row) {
        let ind = this.goods.indexOf(row.id);
        if (ind == -1) {
          this.goods.push(row.id)
        } else {
          this.goods.splice(ind, ind + 1);
        }
      },
      // 分页跳转
      pageChange(e) {
        this.pageIndex = e;
        this._getStockShop();
      },
    },
  };
</script>

<style lang="less" scoped>
  @deep: ~">>>";

  .help {
    margin-left: 10px;
    font-size: 20px;
    vertical-align: middle;
  }

  .card-body {
    padding-top: 10px;
  }

  .w50 {
    width: 50%;
  }

  .w80 {
    width: 80%;
  }

  .pictrueBox {
    display: block;
    margin-bottom: 10px;

    .active {
      border: 2px solid red;
      border-radius: 4px;
    }

    .pictrue {
      width: 74px;
      // height: 78px;
      display: inline-block;
      margin-right: 15px;
      margin-bottom: 10px;
      vertical-align: middle;
      cursor: pointer;
      position: relative;

      img {
        width: 70px;
        height: 70px;
        vertical-align: middle;
        border-radius: 4px;
      }

      .text {
        height: 40px;
        line-height: 20px;
        font-size: 14px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /* 行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
</style>